enum AVATAR_COLOR_STATUS {
    in_a_call = "#FBDC47",
    available = "#2E476B",
    offline = "#ABB1B9",
}
export default AVATAR_COLOR_STATUS